import React from 'react';

const MAX_TIMER_DELAY_MS = 2 ** 31 - 1;

/**
 * True while `Date.now() < availableAt`. One timer is armed for that instant (no polling) so the component
 * re-renders exactly when the wait ends; nothing else happens at that moment, in particular nothing is retried.
 */
export const useCooldown = (availableAt: number | null): boolean => {
    const [tick, setTick] = React.useState(0);

    React.useEffect(() => {
        if (availableAt === null || Number.isNaN(availableAt)) {
            return undefined;
        }
        const remaining = availableAt - Date.now();
        if (remaining <= 0) {
            return undefined;
        }
        // Re-armed through `tick` if the delay had to be clamped.
        const timer = setTimeout(() => setTick((current) => current + 1), Math.min(remaining, MAX_TIMER_DELAY_MS));
        return () => clearTimeout(timer);
    }, [availableAt, tick]);

    return availableAt !== null && Date.now() < availableAt;
};
